/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const ClockCounterClockwiseOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12.382 7.501v4.5l3.9 2.25m-9.169-4.91h-3.75m0 0v-3.75m0 3.75 3.188-3.17a8.214 8.214 0 0 1 4.224-2.26c1.6-.32 3.259-.16 4.767.47a8.25 8.25 0 0 1 3.704 3.03c.907 1.36 1.391 2.96 1.391 4.59s-.484 3.23-1.391 4.58c-.907 1.36-2.196 2.42-3.704 3.04s-3.167.79-4.767.47a8.288 8.288 0 0 1-4.224-2.26"
})); // Fill


const ClockCounterClockwiseFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M13.133 7.5v4.07l3.526 2.03c.142.08.252.21.314.36a.756.756 0 0 1-.69 1.04.631.631 0 0 1-.375-.11l-3.9-2.25h-.018l-.038-.01-.028-.03-.029-.02-.028-.03-.018-.02c-.019-.01-.029-.03-.038-.04l-.019-.01-.018-.04-.019-.03-.019-.03c-.006 0-.01-.01-.014-.01a.105.105 0 0 1-.005-.03l-.018-.02c0-.01-.01-.02-.01-.04-.003 0-.006-.01-.007-.01-.002-.01-.003-.01-.002-.02l-.019-.04c.001 0 0-.01-.002-.01 0-.01-.004-.01-.007-.01 0-.02 0-.03-.01-.04v-.04c0-.02-.009-.03-.009-.04V7.5a.751.751 0 0 1 1.5 0zm5.617-1.87C17.058 3.95 14.77 3 12.383 3s-4.674.95-6.365 2.63l-.778.78L3.9 5.07a.72.72 0 0 0-.383-.21.8.8 0 0 0-.433.04c-.138.06-.255.16-.338.28s-.129.27-.132.41v3.75c0 .2.08.39.22.54.141.14.331.21.53.21h3.75a.728.728 0 0 0 .691-.46.743.743 0 0 0 .046-.43.782.782 0 0 0-.202-.38L6.3 7.47l.778-.78a7.492 7.492 0 0 1 8.173-1.62 7.531 7.531 0 0 1 3.365 2.76A7.518 7.518 0 0 1 19.877 12c0 1.48-.44 2.93-1.264 4.16a7.488 7.488 0 0 1-3.365 2.77c-1.37.56-2.877.71-4.332.42a7.42 7.42 0 0 1-3.84-2.05.766.766 0 0 0-.53-.22.766.766 0 0 0-.53.22.748.748 0 0 0 0 1.06A9 9 0 0 0 21.386 12c0-2.39-.948-4.68-2.636-6.37z"
})); // DuoTone


const ClockCounterClockwiseDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12.382 20.25c4.556 0 8.25-3.7 8.25-8.25 0-4.56-3.694-8.25-8.25-8.25S4.132 7.44 4.132 12c0 4.55 3.694 8.25 8.25 8.25z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12.382 7.5V12l3.9 2.25M7.113 9.34h-3.75m0 0V5.59m0 3.75 3.188-3.17a8.214 8.214 0 0 1 4.224-2.26c1.6-.32 3.259-.16 4.767.47a8.25 8.25 0 0 1 3.704 3.03c.907 1.36 1.391 2.96 1.391 4.59s-.484 3.23-1.391 4.58c-.907 1.36-2.196 2.42-3.704 3.04s-3.167.79-4.767.47a8.288 8.288 0 0 1-4.224-2.26"
}));
/**
  Icon ClockCounterClockwiseIcon in time group
*/


export const ClockCounterClockwiseIcon = createIcon('ClockCounterClockwiseIcon', 'clock-counter-clockwise', 'time', ClockCounterClockwiseOutline, ClockCounterClockwiseFill, ClockCounterClockwiseDuotone, "0 0 24 24");